const LS_LANG_KEY = 'ARISE_LANG_ISO';

export function getSavedLangIso(): string | null {
    try {
        if (process.env.PUBLIC_SUPPORT_TRANSLATIONS !== 'true') {
            console.log(`Not getting ${LS_LANG_KEY} as translations are disabled`);
            return null;
        }
        return window.localStorage.getItem(LS_LANG_KEY);
    } catch {
        return null;
    }
}

export function saveLangIso(langISO: string): void {
    try {
        window.localStorage.setItem(LS_LANG_KEY, langISO);
    } catch {
        // Ignore localStorage errors
    }
}

export function clearSavedLangIso(): void {
    try {
        window.localStorage.removeItem(LS_LANG_KEY);
    } catch {
        // Ignore localStorage errors
    }
}
